import {apiKey} from './api-keys';
import {yunoKey} from './yuno-api-key';
import {algoliaConfig} from './algolia-config';
import {environment as production} from './environment.production';

export const environment = {
  ...production,
  ssr: false,
  hmr: false,
  production: false,
  callCenter: true,
  algoliaConfig,
  deploymentVersion: {developmentMode: true},
  apiKey,
  yunoKey,
  date: new Date(),
};
